/**
 * Raw SignalR messages store with circular buffer (max 1000 items)
 */

import { create } from 'zustand';
import type { RawMessage } from '../../shared/types';

declare global {
  interface Window {
    __vybeExportRawMessages?: () => RawMessage[];
    __vybeExportOrderUpdates?: () => RawMessage[];
  }
}

interface RawMessagesState {
  messages: RawMessage[];
  addMessage: (direction: 'INCOMING' | 'OUTGOING' | 'SYSTEM', method: string, data: unknown) => void;
  clear: () => void;
}

const MAX_MESSAGES = 1000;

export const useRawMessagesStore = create<RawMessagesState>((set) => ({
  messages: [],
  
  addMessage: (direction, method, data) => set((state) => {
    const newMessage: RawMessage = {
      timestamp: new Date(),
      direction,
      method,
      data,
    };

    let newMessages = [...state.messages, newMessage];
    
    // Remove oldest message if we exceed max limit
    if (newMessages.length > MAX_MESSAGES) {
      newMessages = newMessages.slice(-MAX_MESSAGES);
    }

    return { messages: newMessages };
  }),

  clear: () => set({ messages: [] }),
}));

if (typeof window !== 'undefined') {
  window.__vybeExportRawMessages = () => useRawMessagesStore.getState().messages;
  window.__vybeExportOrderUpdates = () =>
    useRawMessagesStore
      .getState()
      .messages.filter((message) => message.method === 'VybeOnOrderUpdate');
}
